export default __webpack_public_path__ + "static/media/22.c0c0602e.png";